import { ValidateProperty } from "../../../models/utilities/validate-property";
import { ShipmentStatus } from "../enums/shipment-status";

export class ShipmentUpdateStatus {

    @ValidateProperty({ required: true})
    public status : ShipmentStatus;
    
    @ValidateProperty({ required: true})
    public rowVersion : string = '';

    constructor(rowVersion : string) {
        this.rowVersion = rowVersion;
    }

}
